import { Skeleton } from "@mui/material"
import { Subscribe } from "@react-rxjs/core"

import { InstrumentLogo } from "@/App/Equities/shared/components"
import { Stack, Typography } from "@/generated/material"
import type { EquityOrder, Instrument } from "@/generated/TradingGateway"

interface Props extends EquityOrder {
  "data-testid": string
  instrument?: Instrument
}

export const OrderHistoryListItem = ({
  symbol,
  side,
  qty,
  filledQty,
  status,
  instrument,
  "data-testid": testId,
}: Props) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap="md"
      padding="xs"
      data-testid={testId}
    >
      <InstrumentLogo symbol={symbol} data-testid={`${testId}.logo`} />

      <Stack flexGrow={1} gap="md" overflow="hidden">
        <Stack direction="row" gap="md" alignItems="baseline">
          <Stack flexGrow={1} overflow="hidden">
            <Typography
              variant="Text lg/Regular"
              color="text.primary"
              sx={{ lineHeight: "normal" }}
              noWrap
              data-testid={`${testId}.name`}
            >
              <Subscribe fallback={<Skeleton />}>
                {instrument?.displayName}
              </Subscribe>
            </Typography>
          </Stack>
          <Typography
            variant="Text lg/Regular"
            sx={{ textTransform: "capitalize", lineHeight: "normal" }}
            color="text.primary"
            data-testid={`${testId}.side`}
          >
            Side: {side}
          </Typography>
        </Stack>
        <Stack direction="row" gap="md" alignItems="baseline">
          <Typography
            flexGrow={1}
            variant="Text lg/Regular"
            color="text-tertiary"
            sx={{ lineHeight: "normal" }}
            data-testid={`${testId}.quantity`}
          >
            {filledQty}/{qty}
          </Typography>
          <Typography
            variant="Text lg/Regular"
            data-testid={`${testId}.status`}
            sx={{ textTransform: "capitalize", lineHeight: "normal" }}
          >
            {status}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  )
}
